import DeviceDetector from "device-detector-js";
//import { position } from "html2canvas/dist/types/css/property-descriptors/position";
const deviceDetector = new DeviceDetector();
export const getUserBrowserAndDeviceInfo = () => {
    if (navigator.userAgent) {
        const browserInfo = deviceDetector.parse(navigator.userAgent);
        return {
            browser: browserInfo.client.name,
            device: browserInfo.device.type
        }
    }
}

export const getGeoLocation = () => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position)=> { 
            localStorage.setItem("latitude",position.coords.latitude)
            localStorage.setItem("longitude",position.coords.longitude)
        });
      }
}
